export const DEFAULT_LABELS = {
	title: 'The anytime-anywhere discovery platform for natural products brands and retailers'
};
